module.exports = __webpack_public_path__ + "static/media/8OLA29.f4f5eed4.jpg";